import axios from 'axios'

/**
 * Extracts tenant from current hostname
 * Production domains: {tenant}.rigadapos.com.mx or {tenant}.rigadapos.com
 * Returns tenant name or 'tizon' as default if not found
 */
const getTenantFromDomain = () => {
    if (typeof window === 'undefined') return 'tizon';

    const hostname = window.location.hostname;

    // Match {tenant}.rigadapos.com.mx or {tenant}.rigadapos.com
    const rigadaPattern = /^([^.]+)\.(rigadapos\.com\.mx|rigadapos\.com)$/;
    const match = hostname.match(rigadaPattern);

    if (match && match[1]) {
        return match[1];
    }

    // For localhost or other domains, fall back to 'tizon' as default tenant
    return 'tizon';
};

/**
 * Constructs backend URL based on environment and tenant
 * Production: https://{tenant}.back.rigadapos.com.mx
 * Development: Uses VUE_APP_SERVER_DOMAIN from .env file
 * Default tenant: 'tizon' if no tenant is specified
 */
const getBackendURL = (tenant) => {
    // Use 'tizon' as default tenant if none provided
    const effectiveTenant = tenant || 'tizon';

    if (process.env.NODE_ENV === 'production') {
        return `https://${effectiveTenant}.back.rigadapos.com.mx/`+effectiveTenant+`/`;
    } else {
        // In development, use configured domain
        // Can be localhost, staging server, or specific tenant backend
        return process.env.VUE_APP_SERVER_DOMAIN+effectiveTenant+`/` || `https://${effectiveTenant}.back.rigadapos.com.mx/`+effectiveTenant+`/`;
    }
};

const getBaseURL = (tenant) => {
    // Use 'tizon' as default tenant if none provided
    const effectiveTenant = tenant || 'tizon';

    if (process.env.NODE_ENV === 'production') {
        return `https://${effectiveTenant}.back.rigadapos.com.mx/`
    } else {
        // In development, use configured domain
        // Can be localhost, staging server, or specific tenant backend
        return process.env.VUE_APP_SERVER_DOMAIN || `https://${effectiveTenant}.back.rigadapos.com.mx/`
    }
};


const state = {
    server: {
        tenant: localStorage.getItem('tenant') || getTenantFromDomain()
    },
};

const getters = {
    tenant: (state) => state.server.tenant,
    backendURL: (state) => getBackendURL(state.server.tenant),
    baseURL: (state) => getBaseURL(state.server.tenant)
};

const actions = {
    /**
     * Initialize tenant from domain on app startup
     */
    initializeTenant({ commit, state }) {
        const domainTenant = getTenantFromDomain();

        if (domainTenant && domainTenant !== state.server.tenant) {
            commit('CH_TENANT_DATA', domainTenant);
            localStorage.setItem('tenant', domainTenant);
        }

        const currentTenant = state.server.tenant;
        if (currentTenant) {
             const backendURL = getBackendURL(currentTenant);
            if (backendURL) {
                axios.defaults.baseURL = backendURL;
            }
        }
    },

    /**
     * Change tenant data and update axios base URL
     * @param {string} tenant - Tenant identifier
     */
    changeTenantData({ commit }, tenant) {
        localStorage.setItem('tenant', tenant);
        const backendURL = getBackendURL(tenant);
        if (backendURL) {
            axios.defaults.baseURL = backendURL;
        }

        commit('CH_TENANT_DATA', tenant);
    },
};

const mutations = {
    CH_TENANT_DATA(state, tenant) {
        state.server.tenant = tenant;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};